import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {DiscussionSummaryModel} from '../model/discussionSummary.model';
import {Injectable} from '@angular/core';
import {MessageConverter} from '../../../../../message/api/model/converter/message.converter';
import {UserSummaryConverter} from '../../../../../account/modules/user/api/converter/userSummary.converter';
import {DiscussionParticipantConverter} from './discussionParticipant.converter';

@Injectable({
    providedIn: 'root',
})
export class DiscussionSummaryConverter extends HttpModelConverter<DiscussionSummaryModel> {

    constructor(private messageConverter: MessageConverter,
                private participantConverter: DiscussionParticipantConverter) {
        super();
    }

    protected createInstance(): DiscussionSummaryModel {
        return new DiscussionSummaryModel();
    }

    protected enrichObject(result: DiscussionSummaryModel, src: DiscussionSummaryModel) {
        result.lastMessage = this.messageConverter.convert(src.lastMessage);
        result.updatedBy = new UserSummaryConverter().convert(src.updatedBy);
        result.createdBy = new UserSummaryConverter().convert(src.createdBy);
        result.participants = this.participantConverter.convertFromArray(src.participants);
    }
}
